import { getVariantEnvironment } from 'owa-metatags/lib/getPhysicalRing';
import { isSovereignCloudInfraEnabled } from './isSovereignCloudInfraEnabled';

/**
 * TEMPORARY WORKAROUND: returns whether the current environment is GCC High or DoD, the
 * clouds where the sovereign cloud infra must always be enabled. This should be removed
 * once the flight infra is fully rolled out.
 */
export function isGccHighOrDod(): boolean {
    const environment = getVariantEnvironment();
    return environment === 'GccHigh' || environment === 'DoD';
}

/**
 * Returns whether the current app environment is sovereign, i.e. we loaded
 * the index.html from a sovereign cloud Outlook endpoint.
 */
export function isSovereignAppEnvironment(): boolean {
    if (!isSovereignCloudInfraEnabled()) {
        return false;
    }

    const environment = getVariantEnvironment();
    return (
        environment !== 'Prod' &&
        environment !== 'GCCModerate' &&
        environment !== 'Dogfood' &&
        environment !== 'Unknown'
    );
}
